import Colors from '../../../../shared/assets/style/default/color';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const SquareItemContainer = styled.div<{ borders: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(165.05deg, #181818 46.89%, #74747450 115.78%);
  border: solid ${2 * Screen.widthRatio}px;
  border-color: ${(props) =>
    props.borders ? Colors['border']['channel'] : 'transparent'};
  border-radius: ${20 * Screen.widthRatio}px;
  cursor: pointer;
  float: left;
  height: ${110 * Screen.widthRatio}px;
  margin-right: ${15 * Screen.widthRatio}px;
  pointer-events: all;
  text-align: center;
  width: ${110 * Screen.widthRatio}px;
  &:hover {
    border: 2px solid white;
  }
`;

// BORDER SHOULD NOT GO THROUGH SCREEN RATIO

export default SquareItemContainer;
